import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AIDevelopmentPage from "../pages/ai-development/page";
import AIInsider from "../pages/ai-insider/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Terms from "../pages/terms/page";
import Security from "../pages/security/page";
import Company from "../pages/company/page";
import FoodPage from "../pages/food/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ai-development",
    element: <AIDevelopmentPage />,
  },
  {
    path: "/ai-insider",
    element: <AIInsider />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/security",
    element: <Security />,
  },
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "/food",
    element: <FoodPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
